/*** IMPORTS FROM imports-loader ***/
var define = false;

import { debounce } from 'underscore'

const isElementInViewport = el => {
    const rect = el.getBoundingClientRect()
    const windowHeight = window.innerHeight
    return (rect.top < (windowHeight - (windowHeight / 6)))
}

const checkElements = elements => {
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i]

        if (isElementInViewport(element)) {
            element.style.opacity = 1
            element.style.transform = 'scale(1)'
        }
    }
}

const loadShowOnScroll = () => {
    const elements = document.querySelectorAll('.show-on-scroll')
    checkElements(elements)

    window.addEventListener('scroll', debounce(() => {
        checkElements(elements)
    }, 20))
}

export default loadShowOnScroll




// WEBPACK FOOTER //
// ./js/showOnScroll.js